type InstructorLoadingVariant = 'dashboard' | 'submissions' | 'courses' | 'detail';

interface InstructorLoadingSkeletonProps {
  message: string;
  variant?: InstructorLoadingVariant;
}

const fourPlaceholders = [0, 1, 2, 3];
const sixPlaceholders = [0, 1, 2, 3, 4, 5];

const InstructorLoadingSkeleton = ({
  message,
  variant = 'dashboard',
}: InstructorLoadingSkeletonProps) => (
  <div className={`instructor-loading-skeleton ${variant}`}>
    <div className="instructor-loading-kicker">
      <span className="instructor-loading-spinner" />
      <span>{message}</span>
    </div>

    {variant === 'dashboard' && (
      <>
        <div className="instructor-skeleton-stat-row">
          {fourPlaceholders.map((item) => (
            <div className="instructor-skeleton-card metric" key={item}>
              <span className="instructor-skeleton-line short" />
              <span className="instructor-skeleton-line value" />
              <span className="instructor-skeleton-line medium" />
            </div>
          ))}
        </div>
        <div className="instructor-skeleton-card toolbar" />
        <div className="instructor-skeleton-dashboard-grid">
          <div className="instructor-skeleton-card table">
            {sixPlaceholders.map((item) => (
              <span className="instructor-skeleton-row" key={item} />
            ))}
          </div>
          <div className="instructor-skeleton-card chart">
            <span className="instructor-skeleton-orbit" />
          </div>
        </div>
      </>
    )}

    {variant === 'submissions' && (
      <div className="instructor-skeleton-review-grid">
        <div className="instructor-skeleton-card list">
          {sixPlaceholders.map((item) => (
            <span className="instructor-skeleton-row" key={item} />
          ))}
        </div>
        <div className="instructor-skeleton-card review">
          <span className="instructor-skeleton-line title" />
          <span className="instructor-skeleton-line wide" />
          <span className="instructor-skeleton-line wide" />
          <span className="instructor-skeleton-line medium" />
          <span className="instructor-skeleton-orbit" />
        </div>
      </div>
    )}

    {variant === 'courses' && (
      <div className="instructor-skeleton-review-grid">
        <div className="instructor-skeleton-card list">
          {fourPlaceholders.map((item) => (
            <span className="instructor-skeleton-row" key={item} />
          ))}
        </div>
        <div className="instructor-skeleton-card review">
          <span className="instructor-skeleton-line title" />
          <span className="instructor-skeleton-line wide" />
          <span className="instructor-skeleton-line wide" />
          <span className="instructor-skeleton-line medium" />
        </div>
      </div>
    )}

    {variant === 'detail' && (
      <>
        <div className="instructor-skeleton-stat-row">
          {fourPlaceholders.map((item) => (
            <div className="instructor-skeleton-card metric" key={item}>
              <span className="instructor-skeleton-line short" />
              <span className="instructor-skeleton-line value" />
            </div>
          ))}
        </div>
        <div className="instructor-skeleton-review-grid">
          <div className="instructor-skeleton-card list">
            {fourPlaceholders.map((item) => (
              <span className="instructor-skeleton-row" key={item} />
            ))}
          </div>
          <div className="instructor-skeleton-card review">
            <span className="instructor-skeleton-line title" />
            <span className="instructor-skeleton-line wide" />
            <span className="instructor-skeleton-line wide" />
            <span className="instructor-skeleton-line medium" />
          </div>
        </div>
      </>
    )}
  </div>
);

export { InstructorLoadingSkeleton };
export type { InstructorLoadingVariant };
